export default __webpack_public_path__ + "static/social-share-785026d44f946ab851d3164dd5bc2c22.png";